<template>
  <div>
    <el-table
      ref="elTable"

      :data="data"
      :stripe="stripe"
      :border="border"
      :tooltip-effect="tooltipEffect"
      :highlight-current-row="highlightCurrentRow"
      v-bind="$attrs"
      @selection-change="handleSelectionChange"
      @row-click="handleRowClick"
    >
      <slot name="preTable" />
      <el-table-column
        v-if="selectable"
        width="30"
        align="center"
        header-align="center"
        class-name="c-table-column--selection"
        :fixed="radioFixed"
      >
        <template
          slot-scope="scope"
        >
          <el-radio
            v-model="selectedRow[rowKey]"
            :label="scope.row[rowKey]"
          />
        </template>
      </el-table-column>
      <el-table-column
        v-if="multiple"
        label
        width="30"
        align="center"
        header-align="center"
        class-name="c-table-column--selection"
        type="selection"
      />
      <template v-for="item in tableColumn">
        <el-table-column
          v-if="item.type==='index'"
          :key="item.key"
          type="index"
          :label="item.label"
          :prop="item.key"
          :width="item.width"
          :min-width="item.minWidth"
          align="center"
          header-align="center"
          :fixed="item.fixed"
          :class-name="item.className"
          :label-class-name="item.labelClassName"
        />
        <el-table-column
          v-else-if="item.children"
          :key="item.key"
          :label="item.label"
          :prop="item.key"
          :header-align="item.headerAlign"
          :width="item.width"
          :class-name="item.className"
        >
          <el-table-column
            v-for="subItem in item.children"
            :key="subItem.key"
            :label="subItem.label"
            :prop="item.key"
            :width="subItem.width"
            :min-width="subItem.minWidth"
            :align="subItem.align"
            :header-align="subItem.headerAlign"
            :fixed="item.fixed"
            :column-key="subItem.columnKey"
            :class-name="subItem.className"
            :label-class-name="subItem.labelClassName"
            :show-overflow-tooltip="!!tooltipEffect"
          >
            <template
              slot-scope="subScope"
            >
              <slot
                v-if="subItem.slotName"
                :name="subItem.slotName"
                :row="subScope.row"
                :index="subScope.$index"
                :column="subScope.column"
                :table-column="subItem"
              />
              <template v-else-if="subItem.type === 'date'">
                {{ subScope.row[subItem.key] | date("yyyy-MM-dd") }}
              </template>
              <template v-else-if="subItem.type === 'dateTime'">
                {{ subScope.row[subItem.key] | date("yyyy-MM-dd HH:mm:ss") }}
              </template>
              <template
                v-else
              >
                {{ subScope.row[subItem.key] }}
              </template>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column
          v-else
          :key="item.key"
          :label="item.label"
          :prop="item.key"
          :width="item.width"
          :min-width="item.minWidth"
          :align="item.align"
          :header-align="item.headerAlign"
          :fixed="item.fixed"
          :column-key="item.columnKey"
          :class-name="item.className"
          :label-class-name="item.labelClassName"
          :show-overflow-tooltip="!!tooltipEffect"
        >
          <template
            slot-scope="scope"
          >
            <slot
              v-if="item.slotName"
              :name="item.slotName"
              :row="scope.row"
              :index="scope.$index"
              :column="scope.column"
              :table-column="item"
            />
            <template v-else-if="item.type === 'date'">
              {{ scope.row[item.key] | date("yyyy-MM-dd") }}
            </template>
            <template v-else-if="item.type === 'dateTime'">
              {{ scope.row[item.key] | date("yyyy-MM-dd HH:mm:ss") }}
            </template>
            <template
              v-else
            >
              {{ scope.row[item.key] }}
            </template>
          </template>
        </el-table-column>
      </template>
      <slot />
    </el-table>
    <el-pagination
      v-if="paginationShow"
      ref="elPagination"
      class="c-page__pagination"
      :disabled="pagination.total <= 0 || loading"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      :current-page="pagination.pageNo"
      :layout="pagination.layout || pageLayout"
      :page-sizes="pagination.pageSizes || pageSizes"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      @prev-click="handlePrevClick"
      @next-click="handleNextClick"
    />
  </div>
</template>

<script>
import resize from 'vue-resize-directive';
// import elTableInfiniteScroll from 'el-table-infinite-scroll';

export default {
  name: 'KTableInfinite',
  directives: {
    resize
    // 'el-table-infinite-scroll': elTableInfiniteScroll
  },
  inheritAttrs: false,
  props: {
    value: {
      type: [Object, Array],
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: function () {
        return [];
      }
    },
    tableColumn: {
      type: Array,
      required: true,
      default: function () {
        return [];
      }
    },
    paginationShow: {
      type: Boolean,
      default: true
    },
    pagination: {
      type: Object,
      default: function () {
        return {
          total: 0,
          pageSize: 15,
          pageNo: 0
        };
      }
    },
    multiple: { // 是否多选
      type: [Boolean, String],
      default: false
    },
    selectable: { // 是否可选（单选）
      type: [Boolean, String],
      default: false
    },
    rowKey: {
      type: String,
      default: null
    },
    stripe: {
      type: Boolean,
      default: true
    },
    border: {
      type: Boolean,
      default: true
    },
    tooltipEffect: {
      type: String,
      default: 'dark'
    },
    highlightCurrentRow: {
      type: Boolean,
      default: true
    },
    isFullPage: {
      type: Boolean,
      default: true
    }
    // infiniteScrollImmediate: {
    //   type: Boolean,
    //   default: true
    // },
    // infiniteScrollDisabled: {
    //   type: Boolean,
    //   default: false
    // }
  },
  data () {
    return {
      radioFixed: false,
      pageSizes: [15, 20, 30],
      pageLayout: 'total, sizes, prev, pager, next, jumper'
    };
  },
  computed: {
    multipleSelectedRow: {
      get () {
        if (this.multiple) {
          return this.value || [];
        } else {
          return [];
        }
      },
      set (newValue) {
        this.$emit('input', newValue);
      }
    },
    selectedRow: {
      get () {
        if (this.selectable) {
          return this.value || {};
        } else {
          return {};
        }
      },
      set (newValue) {
        this.$emit('input', newValue);
      }
    }
  },
  methods: {
    // handleInfinite () {
    //   this.$emit('infiniteLoad');
    // },
    /**
     * @description: currentPage 改变时会触发
     * @param {*} event 当前页
     * @return {*}
     */
    handleCurrentChange ($event) {
      this.$emit('current-change', $event);
    },
    /**
     * @description: pageSize 改变时会触发
     * @param {*} event 每页条数
     * @return {*}
     */
    handleSizeChange ($event) {
      this.$emit('size-change', $event);
    },
    /**
     * @description: 用户点击上一页按钮改变当前页后触发
     * @param {*} event 当前页
     * @return {*}
     */
    handlePrevClick ($event) {
      this.$emit('prev-click', $event);
    },
    /**
     * @description: 用户点击下一页按钮改变当前页后触发
     * @param {*} event 当前页
     * @return {*}
     */
    handleNextClick ($event) {
      this.$emit('next-click', $event);
    },
    /**
     * @description: 表格选中行事件（多选）
     * @param {Object} val
     * @return:
     */
    handleSelectionChange (val) {
      this.multipleSelectedRow = val;
      this.$emit('selection-change', val);
    },
    /**
     * @description: 表格选中行事件（单选）
     * @param {Object} row
     * @param {Object} column
     * @param {any} event
     * @return {*}
     */
    handleRowClick (row, column, event) {
      this.selectedRow = row;
      this.$emit('row-click', { row, column, event });
    },
    /**
     * @description: 对 Table 进行重新布局。当 Table 或其祖先元素由隐藏切换为显示时，可能需要调用此方法
     * @param {*}
     * @return {*}
     */
    doLayout () {
      if (!this.$refs.elTable) {
        console.error('表格DOM结构未生成，无法获取元素！');
      } else {
        this.$nextTick(() => {
          this.$refs.elTable.doLayout();
        });
      }
    },
    /**
     * @description: 依据设置纠正radio选择框的位置，避免表格列设定fixed，radio位置不正确
     * @param {*}
     * @return {*}
     */
    initRadioFixed () {
      if (typeof this.selectable === 'string') {
        this.radioFixed = this.selectable;
      } else {
        const fixed = this.tableColumn.filter(item => item.fixed && item.fixed !== 'right');
        if (fixed.length > 0) {
          this.radioFixed = true;
        }
      }
    },
    /**
     * @description: 检查组件入参
     * @param {*}
     * @return {*}
     */
    initCheckProp () {
      // 单选框必须有key值
      if (this.selectable && !this.rowKey) {
        console.error('表格单选必须配合rowKey！');
      }
    }
  },
  created () {
    this.initCheckProp();
    this.initRadioFixed();
  }
};
</script>

<style>

</style>
